module.exports = __webpack_public_path__ + "vue_assets/img/img_header_desert.65d35d00.jpg";